import { createContext, useContext } from 'react';
import { UsersTableContextData as ContextData } from './types';

const context = createContext<ContextData>({} as ContextData);

export const { Provider } = context;

export const useUsersTableContext = () => useContext(context);
